"use client"

import { createConsumer } from "@rails/actioncable"

let consumer: ReturnType<typeof createConsumer> | null = null
let cachedToken: string | undefined

function devCableBaseUrl(): string | null {
  if (process.env.NODE_ENV !== "development") return null
  if (!process.env.NEXT_PUBLIC_CABLE_VIA_REWRITE) return null
  if (typeof window === "undefined") return null
  return window.location.origin
}

function buildCableUrl(token?: string) {
  const baseUrl = devCableBaseUrl() || process.env.NEXT_PUBLIC_API_URL?.replace("/api/", "") || "http://localhost:3000"
  const wsUrl = baseUrl.replace(/^http/, "ws")
  return token ? `${wsUrl}/cable?token=${token}` : `${wsUrl}/cable`
}

export function updateCableToken(token: string) {
  cachedToken = token
}

export function getConsumer(token?: string) {
  if (token) cachedToken = token

  if (!consumer) {
    // Pass a function so ActionCable calls it on every (re)connect attempt,
    // using the latest cached token instead of a stale one.
    consumer = createConsumer(() => buildCableUrl(cachedToken))
  }
  return consumer
}

export function disconnectConsumer() {
  if (consumer) {
    consumer.disconnect()
    consumer = null
  }
}
